import React, {useEffect, useState} from "react";
import {IPagesProps} from "../../../contracts/pages";
import useToastNotify from "../../../hook/useToastNotify";
import {useLocation} from "react-router-dom";
import useQuery from "../../../hook/useQuery";
import {
    generateTransactionWalletTypeTitle,
    generateUserTypeTitle,
    isNotEmpty, priceFormatWithUnitToman
} from "../../../helpers/functions";
import httpClient from "../../../services/httpClient";
import {usersApi} from "../../../constans/apiUrls";
import TableTr from "../../Elements/Table/TableTr";
import TableTd from "../../Elements/Table/TableTd";
import TableTdContent from "../../Elements/Table/TableTdContent";
import MenuDrop from "../../Elements/MenuDrop";
import MenuDropItem from "../../Elements/MenuDrop/MenuDropItem";
import Table from "../../Elements/Table";
import TableEmpty from "../../Elements/Table/TableEmpty";
import PageHeader from "../../Elements/PageHeader";
import {IRouterListToData} from "../../../contracts/data/router";
import {IUserWalletInfoData, IUserWalletTransactionsData} from "../../../contracts/data/user";
import DetailsCard from "../../Elements/DetailsCard";
import { AiOutlineEye } from "react-icons/ai";
import MyModal from "../../Elements/MyModal";
import NewTransactionWalletUserForm from "../../../forms/dashboard/user/NewTransactionWalletUserForm";
import {TransactionWalletType} from "../../../constans/enumTypes";

const UserWallet: React.FC<IPagesProps> = () => {
    const {toastNotify} = useToastNotify();
    const location = useLocation<IRouterListToData>()
    const queryParams = useQuery()
    const [info, setInfo] = useState<IUserWalletInfoData>({
        id: 0,
        price: 0,
        withdraw_price: 0,
        deposit_price: 0
    });
    const [data, setData] = useState<Array<IUserWalletTransactionsData>>([]);
    const [countItems, setCountItems] = useState<number>(0);
    const [showTransactionModal, setShowTransactionModal] = useState<boolean>(false);
    const [showNewTransactionModal, setShowNewTransactionModal] = useState<boolean>(false);
    const [selectTransaction, setSelectTransaction] = useState<IUserWalletTransactionsData>();
    const [loading, setLoading] = useState<boolean>(true);
    const [reload, setReload] = useState<boolean>(false);

    const titleHeadTable: Array<string> = ['#', 'ایجاد کننده', 'مبلغ', 'نقش ایجاد کننده', 'نوع تراکنش', 'زمان ایجاد', 'عملیات']

    const fetchWalletInfo = async () => {
        await httpClient().get(`${usersApi.wallet_info}/${queryParams.get('id')}`)
            .then(response => {
                if (response.status === 200) {
                    setInfo(response?.data?.data)
                }
            })
            .catch(error => toastNotify('error', 'مشکلی در دریافت لیست آیتم ها وجود دارد'))
            .finally(() => setLoading(false))
    }

    const fetchItemsData = async (search: string | null | undefined = "") => {
        await httpClient().get(`${usersApi.wallet_transactions}/${queryParams.get('id')}`)
            .then(response => {
                if (response.status === 200) {
                    setData(response?.data?.data)
                    setCountItems(response?.data?.data.length)
                }
            })
            .catch(error => toastNotify('error', 'مشکلی در دریافت لیست آیتم ها وجود دارد'))
            .finally(() => setLoading(false))
    }

    const handlerNewTransaction = (newTransaction: IUserWalletTransactionsData) => {
        let tempData:Array<IUserWalletTransactionsData> = []
        tempData = data
        tempData.unshift(newTransaction)
        setData(tempData)
    }

    const handleUpdateWalletPriceWithTransaction = (newTransaction:  IUserWalletTransactionsData) => {
        if(newTransaction?.type === TransactionWalletType.DEPOSIT){
            setInfo({
                ...info,
                price: info?.price + newTransaction?.price,
                deposit_price: info?.deposit_price + newTransaction?.price,
            })
        }else{
            setInfo({
                ...info,
                price: info?.price - newTransaction?.price,
                withdraw_price: info?.withdraw_price + newTransaction?.price,
            })
        }
    }

    useEffect(() => {
        fetchWalletInfo()
        fetchItemsData()
    }, [])

    useEffect(() => {
        if (reload) {
            setReload(false)
        }
    }, [reload])

    const itemsTableRows = data.map((item, index) =>
        <TableTr key={`table-row${index}`}>
            <TableTd><TableTdContent content={`${index + 1}`}/></TableTd>
            <TableTd><TableTdContent content={item?.user_info?.first_name + " " + item?.user_info?.last_name} customClassName={"text-sm"}/></TableTd>
            <TableTd><TableTdContent content={priceFormatWithUnitToman(item?.price)} customClassName={"text-sm"}/></TableTd>
            <TableTd><TableTdContent content={generateUserTypeTitle(item?.user_type)} customClassName={"text-sm"}/></TableTd>
            <TableTd><TableTdContent content={generateTransactionWalletTypeTitle(item?.type)} customClassName={"text-sm w-36 truncate"}/></TableTd>
            <TableTd><TableTdContent content={item?.created_time_jalali?.split(",")[1]} customClassName={"text-sm"}/></TableTd>
            <TableTd>
                <MenuDrop>
                    <MenuDropItem title={"مشاهده جزییات"} icon={<AiOutlineEye />} handleOnSubmit={() => {
                        setSelectTransaction(item)
                        setShowTransactionModal(true)
                    }} />
                </MenuDrop>
            </TableTd>
        </TableTr>
    )

    return(
        <React.Fragment>
            <MyModal isOpen={showTransactionModal}
                     title={`جزییات تراکنش`}
                     btnPrimaryTxt={"متوجه شدم"} handlerPrimaryButton={() => setShowTransactionModal(false)}>
                <div>{`توضیحات تراکنش: ${selectTransaction?.description}`}</div>
            </MyModal>
            <MyModal isOpen={showNewTransactionModal}
                     title={`تراکنش جدید`}
                     btnSecondaryTxt={"بیخیال"} handlerSecondaryButton={() => setShowNewTransactionModal(false)}>
                <NewTransactionWalletUserForm userId={parseInt(queryParams.get('id')!)} handleCloseModal={(value: IUserWalletTransactionsData) => {
                    handlerNewTransaction(value)
                    handleUpdateWalletPriceWithTransaction(value)
                    setShowNewTransactionModal(false)
                }} />
            </MyModal>
            <PageHeader title={`اطلاعات کیف پول "${isNotEmpty(queryParams.get('name')) ? queryParams.get('name') : ""}"`} isBackBtn
                        urlBackBtn={`${(typeof location?.state?.page !== 'undefined') ? location?.state?.page : "/dashboard/users/list"}?page_num=${(typeof location?.state?.page_num !== 'undefined') ? location?.state?.page_num : 1}`}
                        isFirstBtn={true} firstBtnTitle={'تراکنش جدید'} handlerFirstBtn={() => setShowNewTransactionModal(true)}
            />
            <div className={"border rounded-xl bg-blue-50 p-4 mb-14"}>
                <div className={"mb-4"}>
                    <DetailsCard title={"مبلغ کل"} content={info?.price! > 0 ? priceFormatWithUnitToman(info?.price!) : "-"} />
                </div>
                <div className={"grid grid-cols-1 md:grid-cols-2 gap-4"}>
                    <DetailsCard title={"مبلغ برداشت"} content={info?.withdraw_price! > 0 ? priceFormatWithUnitToman(info?.withdraw_price!) : "-"} />
                    <DetailsCard title={"مبلغ واریز"} content={info?.deposit_price! > 0 ? priceFormatWithUnitToman(info?.deposit_price!) : "-"} />
                </div>
            </div>
            <Table isLoading={loading} title={`لیست تراکنش ها`} subTitle={`تعداد کل: ${countItems}`} titlesTable={titleHeadTable} isSearch={false}>
                {itemsTableRows.length > 0 ? itemsTableRows :
                    <TableEmpty colSpan={titleHeadTable.length} message={"تراکنشی یافت نشد"}/>}
            </Table>
        </React.Fragment>
    )
}

export default UserWallet
